import React from "react";
import { getMicToggleLetter, MIC_TOGGLE_TARGET } from "../utils/micStartTarget";

const MicTargetLetterBadge = ({
  toggleTarget,
  compact = false,
  repositionByTarget = false,
}) => {
  const isReport = toggleTarget === MIC_TOGGLE_TARGET.REPORT;
  const onLeft = repositionByTarget && isReport;

  return (
    <span
      className={`pointer-events-none absolute z-20 flex items-center justify-center rounded-full border border-white font-bold leading-none shadow-sm dark:border-gray-800 ${
        compact
          ? onLeft
            ? "-left-0.5 -top-0.5 h-3.5 w-3.5 text-[8px] sm:-left-1 sm:-top-1 sm:h-4 sm:w-4 sm:text-[9px]"
            : "-right-0.5 -top-0.5 h-3.5 w-3.5 text-[8px] sm:-right-1 sm:-top-1 sm:h-4 sm:w-4 sm:text-[9px]"
          : onLeft
          ? "-left-1 -top-1 h-4 w-4 text-[9px] sm:-left-1.5 sm:-top-1.5 sm:h-[18px] sm:w-[18px] sm:text-[10px]"
          : "-right-1 -top-1 h-4 w-4 text-[9px] sm:-right-1.5 sm:-top-1.5 sm:h-[18px] sm:w-[18px] sm:text-[10px]"
      } ${
        isReport
          ? "bg-blue-500 text-white"
          : "bg-gray-500 text-white dark:bg-gray-400 dark:text-gray-900"
      }`}
      aria-hidden
    >
      {getMicToggleLetter(toggleTarget)}
    </span>
  );
};

export default MicTargetLetterBadge;
